import { render, staticRenderFns } from "./HomeSectionIntro.vue?vue&type=template&id=12f8c2b8&scoped=true&"
import script from "./HomeSectionIntro.vue?vue&type=script&lang=ts&"
export * from "./HomeSectionIntro.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSectionIntro.vue?vue&type=style&index=0&id=12f8c2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8c2b8",
  null
  
)

export default component.exports